import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

export interface PersistedDateRange {
  startIso: string;
  endIso: string;
}

interface UiFiltersState {
  dashboardDateRange: PersistedDateRange | null;
  jobsDateRange: PersistedDateRange | null;
  setDashboardDateRange: (range: PersistedDateRange) => void;
  setJobsDateRange: (range: PersistedDateRange) => void;
  clearDashboardDateRange: () => void;
  clearJobsDateRange: () => void;
}

export const useUiFiltersStore = create<UiFiltersState>()(
  persist(
    (set) => ({
      dashboardDateRange: null,
      jobsDateRange: null,
      setDashboardDateRange: (range: PersistedDateRange) =>
        set({ dashboardDateRange: range }),
      setJobsDateRange: (range: PersistedDateRange) =>
        set({ jobsDateRange: range }),
      clearDashboardDateRange: () => set({ dashboardDateRange: null }),
      clearJobsDateRange: () => set({ jobsDateRange: null }),
    }),
    {
      name: 'ui-filters-storage',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        dashboardDateRange: state.dashboardDateRange,
        jobsDateRange: state.jobsDateRange,
      }),
    },
  ),
);
